import React from 'react';
import Reveal from './Reveal';

export default function SectionHead({ eyebrow, title, lead, align = 'center' }) {
  return (
    <Reveal className={`section-head section-head--${align}`}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="section-title">{title}</h2>
      {lead && <p className="section-lead">{lead}</p>}
    </Reveal>
  );
}
